import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { View, TextInput, 
//Button,
StyleSheet, TouchableOpacity, Text, Image, 
//StatusBar,
ScrollView, Platform, Keyboard, Alert, } from 'react-native';
import { useAuth } from '../../Tools/AuthContext';
import { 
//getToken,
postComment, postCommentExpert, } from '../../Tools/Web/apiPost';
import { 
//getQuestion,
getOptionsByQuestionID, getCommentsByQuestionID, getCommentsExpertByQuestionID, } from '../../Tools/Web/apiGet';
// import {useNavigation} from '@react-navigation/native';
import { paiMap, actionMap, screenWidth, picRatio, SERVER_IP_PORT, } from '../../Tools/config';
import { formatDateTime, parseJwt } from '../../Tools/utils';
const DOUBLE_PRESS_DELAY = 300; // 定义双击的时间间隔
// 组件定义
const QuestionHead = ({ qp, style, onImagePress, onImageDoublePress }) => {
    const lastPress = useRef(0);
    const handlePress = (event) => {
        const now = Date.now();
        if (lastPress.current && (now - lastPress.current) < DOUBLE_PRESS_DELAY) {
            // 检测到双击
            if (onImageDoublePress) {
                onImageDoublePress();
            }
        }
        else {
            // 检测到单击
            if (onImagePress) {
                onImagePress();
            }
        }
        lastPress.current = now;
    };
    return (_jsxs(View, { style: styles.top, children: [_jsx(Text, { style: styles.title, children: qp.title }), _jsx(TouchableOpacity, { onPress: handlePress, activeOpacity: 1, children: _jsx(Image, { source: { uri: SERVER_IP_PORT + qp.image_desktop }, style: style }) })] }));
};
export const QuestionDetailScene = ({ route, navigation }) => {
    const qp = route.params;
    const [options, setOptions] = useState([]);
    const [probVis, setProbVis] = useState(false);
    const [comment, setComment] = useState('');
    const [comments, setComments] = useState([]);
    const [expert, setExpert] = useState(false); //是否是专家
    const [commentExpert, setCommentExpert] = useState('');
    const [commentsExpert, setCommentsExpert] = useState([]);
    const [headVis, setHeadVis] = useState(true);
    const [imageBigger, setImageBigger] = useState(false);
    const textInputRef1 = useRef(null);
    const textInputRef2 = useRef(null);
    const act = useAuth();
    // if (!act) {
    //   return <View />;
    // }
    // const {
    //   accessToken,
    //   // setAccessToken,
    //   // refreshToken,
    //   // setRefreshToken,
    //   // needLogin,
    //   // setNeedLogin,
    //   // needLogo,
    //   // setNeedLogo,
    //   dataFlag,
    //   //setDataFlag,
    // } = act;
    const addComment = (commentX) => {
        setComments([commentX, ...comments]);
    };
    const addCommentExpert = (commentExpertX) => {
        setCommentsExpert([commentExpertX, ...commentsExpert]);
    };
    // const articles = await getQuestion(act);
    // console.log("articles", articles);
    useEffect(() => {
        const fetchData = async () => {
            if (act) {
                //const { accessToken, setAccessToken, refreshToken, setRefreshToken } = act;
                //console.log('accessToken1', accessToken);
                //console.log('refreshToken1', refreshToken);
                // if(accessToken === ""){
                //   return ;
                // }
                try {
                    const options_temp = await getOptionsByQuestionID(qp.id, act);
                    if (options_temp) {
                        console.log('options_temp', options_temp);
                        options_temp.sort((a, b) => a.order - b.order);
                        console.log('options_temp', options_temp);
                        setOptions(options_temp);
                    }
                }
                catch (error) {
                    console.error('Failed to fetch options:', error);
                }
                //解析accessToken，得到expert字段，方便表现
                if (act.accessToken) {
                    const decoded = parseJwt(act.accessToken);
                    console.log('accessToken', decoded);
                    setExpert(decoded.expert);
                }
                try {
                    const comments_temp = await getCommentsByQuestionID(qp.id, act);
                    console.log('comments_temp', comments_temp);
                    if (comments_temp) {
                        setComments(comments_temp);
                    }
                }
                catch (error) {
                    console.error('Failed to fetch comments:', error);
                }
                try {
                    const commentsExpert_temp = await getCommentsExpertByQuestionID(qp.id, act);
                    console.log('commentsExpert_temp', commentsExpert_temp);
                    if (commentsExpert_temp) {
                        setCommentsExpert(commentsExpert_temp);
                    }
                }
                catch (error) {
                    console.error('Failed to fetch commentsExpert:', error);
                }
            }
        };
        setOptions([]);
        setExpert(false);
        setComments([]);
        setCommentsExpert([]);
        fetchData();
    }, [qp.id, act?.dataFlag]);
    const handlePress = () => {
        // 在这里处理点击事件
        console.log('Option BG clicked');
        setProbVis(!probVis);
    };
    const handleSubmitComment = async () => {
        // 在这里处理你的评论提交逻辑，例如发送到服务器
        //console.log('Submitted Comment:', comment);
        if (act) {
            try {
                if (act.accessToken === '') {
                    act.setNeedLogin(true);
                    return;
                }
                if (comment === '') {
                    Alert.alert('警告', '请输入有效的内容');
                    return;
                }
                const commentX = await postComment(qp.id, comment, act);
                console.log('commentX', commentX);
                if (commentX) {
                    addComment(commentX);
                    setComment(''); // 提交后清空输入框
                }
            }
            catch (error) {
                console.error('Failed to submit comment:', error);
            }
        }
    };
    const handleSubmitCommentExpert = async () => {
        if (act) {
            try {
                if (act.accessToken === '') {
                    act.setNeedLogin(true);
                    return;
                }
                if (commentExpert === '') {
                    Alert.alert('警告', '请输入有效的内容');
                    return;
                }
                const commentExpertX = await postCommentExpert(qp.id, commentExpert, act);
                console.log('commentExpertX', commentExpertX);
                if (commentExpertX) {
                    addCommentExpert(commentExpertX);
                    // 提交后清空输入框
                    setCommentExpert('');
                }
            }
            catch (error) {
                console.error('Failed to submit commentExpert:', error);
            }
        }
    };
    useEffect(() => {
        // 监听键盘显示事件
        const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', _keyboardDidShow);
        // 监听键盘隐藏事件
        const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', _keyboardDidHide);
        // 清理函数
        return () => {
            keyboardDidShowListener.remove();
            keyboardDidHideListener.remove();
        };
    }, []);
    const _keyboardDidShow = () => {
        setHeadVis(false);
        // console.log('键盘显示');
        // 在这里处理键盘显示时的逻辑
    };
    const _keyboardDidHide = () => {
        setHeadVis(true);
        if (textInputRef1.current) {
            textInputRef1.current.blur();
        }
        if (textInputRef2.current) {
            textInputRef2.current.blur();
        }
        // console.log('键盘隐藏');
        // 在这里处理键盘隐藏时的逻辑
    };
    const handleFocus = () => {
        setHeadVis(false);
        setImageBigger(false);
    };
    const handleBlur = () => {
        setHeadVis(true);
    };
    const handleImageDoublePress = () => {
        //console.log("image Double Click");
        setImageBigger(prevState => !prevState);
    };
    return (_jsxs(View, { style: styles.container, children: [Platform.OS !== 'web' && (_jsx(QuestionHead, { qp: qp, 
                //style={headVis ? styles.desktop_normal : styles.desktop_small}
                style: imageBigger ? styles.desktop_normal_bigger : styles.desktop_normal, onImageDoublePress: handleImageDoublePress })), _jsxs(ScrollView, { style: styles.scrollView, children: [Platform.OS === 'web' && (_jsx(QuestionHead, { qp: qp, style: styles.desktop_web })), _jsxs(TouchableOpacity, { activeOpacity: 1, style: styles.optionBG, onPress: handlePress, children: [_jsxs(View, { style: styles.optionRow, children: [_jsx(Text, { style: styles.column, children: "\u64CD\u4F5C" }), _jsx(Text, { style: styles.column, children: "\u724C" }), _jsx(Text, { style: styles.column, children: "\u6982\u7387" })] }), options.map(option => (_jsxs(View, { style: styles.optionRow, children: [_jsx(Text, { style: styles.column, children: actionMap.get(option.action) }), _jsxs(Text, { style: styles.column, children: [paiMap.get(option.pai1), " ", paiMap.get(option.pai2)] }), _jsx(Text, { style: [styles.column, !probVis && styles.hidden], children: option.prob.toFixed(2) })] }, option.id)))] }), _jsxs(View, { style: styles.container, children: [commentsExpert.length > 0 && probVis && (_jsxs(_Fragment, { children: [_jsx(Text, { style: styles.input_title, children: "\u4E13\u5BB6\u89E3\u6790\uFF1A" }), commentsExpert.map(commentExpertM => (_jsxs(View, { style: styles.commentContainer, children: [_jsx(Text, { style: styles.name, children: commentExpertM.author_name }), _jsx(Text, { style: styles.content, children: commentExpertM.content }), _jsx(Text, { style: styles.date, children: formatDateTime(commentExpertM.created_date) })] }, commentExpertM.id)))] })), expert && (_jsxs(_Fragment, { children: [_jsx(Text, { style: styles.input_title, children: "\u89E3\u6790\uFF1A" }), _jsx(TextInput, { ref: textInputRef1, style: styles.input, placeholder: "", value: commentExpert, onChangeText: setCommentExpert, onFocus: handleFocus, onBlur: handleBlur }), _jsx(TouchableOpacity, { onPress: handleSubmitCommentExpert, style: styles.button, children: _jsx(Text, { style: styles.text, children: "\u63D0\u4EA4" }) })] })), _jsx(Text, { style: styles.input_title }), _jsx(Text, { style: styles.input_title, children: "\u7528\u6237\u8BC4\u8BBA\uFF1A" }), comments.map(commentM => (_jsxs(View, { style: styles.commentContainer, children: [_jsx(Text, { style: styles.name, children: commentM.author_name }), _jsx(Text, { style: styles.content, children: commentM.content }), _jsx(Text, { style: styles.date, children: formatDateTime(commentM.created_date) })] }, commentM.id))), _jsx(Text, { style: styles.input_title, children: "\u8BC4\u8BBA\uFF1A" }), _jsx(TextInput, { ref: textInputRef2, style: styles.input, placeholder: "", value: comment, onChangeText: setComment, onFocus: handleFocus, onBlur: handleBlur }), _jsx(TouchableOpacity, { onPress: handleSubmitComment, style: styles.button, children: _jsx(Text, { style: styles.text, children: "\u63D0\u4EA4" }) })] })] }), _jsx(TouchableOpacity, { style: styles.backButton, onPress: () => navigation.goBack(), children: _jsx(Image, { source: require('../../assets/2.webp'), style: { width: 40, height: 40, opacity: 0.2 } }) })] }));
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        //padding: 20,
        paddingBottom: Platform.OS === 'web' ? 0 : 0,
    },
    top: {
        //flex: 3,
        backgroundColor: '#ffffff',
        padding: 0,
        marginVertical: 0,
        marginHorizontal: 0,
        justifyContent: 'center',
        alignItems: 'center', // 这会水平居中子视图
        //transform: [{ scale: 0.5 }]
    },
    title: {
        fontSize: 28,
        fontWeight: 'bold',
    },
    desktop_web: {
        width: screenWidth * 0.8,
        height: screenWidth * picRatio * 0.8,
    },
    desktop_normal: {
        width: screenWidth * 1,
        height: screenWidth * picRatio * 1,
    },
    desktop_normal_bigger: {
        width: screenWidth * 1.35,
        height: screenWidth * picRatio * 1.35,
    },
    desktop_small: {
        width: screenWidth * 1,
        height: screenWidth * picRatio * 1,
    },
    xun: {
        fontSize: 24,
    },
    optionBG: {
        backgroundColor: '#ffffff',
        padding: 0,
        marginVertical: 8,
        marginHorizontal: 0,
        // justifyContent: 'center', // 这会垂直居中子视图
        // alignItems: 'center', // 这会水平居中子视图
    },
    optionRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10,
        padding: 10,
        borderWidth: 1,
        borderColor: '#ddd',
        borderRadius: 5,
    },
    column: {
        fontSize: 16,
        textAlign: 'center',
        width: 80, // 你可以根据具体的宽度来调整
    },
    columnName: {
        fontWeight: 'bold',
    },
    scrollView: {
        flex: 1, // 可能需要调整或移除此样式，取决于你的布局需求
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        width: '100%',
        padding: 10,
    },
    cell: {
        flex: 1,
        margin: 2,
        backgroundColor: '#fff',
        textAlign: 'center',
        fontSize: 24,
    },
    hidden: {
        opacity: 0,
    },
    input_title: {
        fontSize: 16,
        textAlign: 'left',
        width: 100,
        padding: 5,
        fontWeight: 'bold',
    },
    input: {
        width: '100%',
        borderColor: 'gray',
        borderWidth: 1,
        padding: 5,
        marginBottom: 10,
    },
    commentContainer: {
        padding: 10,
        borderBottomWidth: 1,
        borderBottomColor: '#ccc',
    },
    name: {
        fontWeight: 'bold',
    },
    content: {
        marginTop: 5,
    },
    date: {
        marginTop: 5,
        fontSize: 12,
        color: '#999',
    },
    button: {
        alignItems: 'center',
        backgroundColor: '#007bff',
        padding: 10,
        width: '100%',
        borderRadius: 0, // 可选：添加圆角
    },
    text: {
        color: '#ffffff',
    },
    backButton: {
        position: 'absolute',
        top: 0,
        left: 0,
        padding: 2, // 增加点击区域
    },
});
export default QuestionDetailScene;
